import {
  ADDNEWVOUCHERMAPPING_SUCCESS,
  ADDNEWVOUCHERMAPPING_FAILED,
  RESET_ADDNEWVOUCHERMAPPING,
  LOADING_ADDNEWVOUCHERMAPPING,
  NETWORK_ERROR_ADDNEWVOUCHERMAPPING,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetAddNewVoucherMapping = () => {
  return { type: RESET_ADDNEWVOUCHERMAPPING };
};

const addNewVoucherMappingList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDNEWVOUCHERMAPPING });
    await partnerServices
      .post("addNewVoucherMapping", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.data.status) {
          case "Success":
            dispatch(addNewVoucherMappingListsuccess(res.data));
            break;
          default:
            dispatch(addNewVoucherMappingListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_ADDNEWVOUCHERMAPPING,
          payload: err,
        });
      });
  };
function addNewVoucherMappingListsuccess(data) {
  return {
    type: ADDNEWVOUCHERMAPPING_SUCCESS,
    payload: data,
  };
}
function addNewVoucherMappingListFailed(data) {
  return {
    type: ADDNEWVOUCHERMAPPING_FAILED,
    payload: data,
  };
}

export { resetAddNewVoucherMapping, addNewVoucherMappingList };
